<template>
  <div v-if="!isLoggedIn" :class="$className.m3LoginLink.root">
    <a :href="loginUrl" :class="$className.m3LoginLink.link">
      <slot />
    </a>
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
const store = useStore();

const loginUrl = computed(() => store.state.requestParam.m3_login_url);
const isLoggedIn = computed(() => store.state.masterData.is_logged_in);
</script>
